import { setCases, setShipmentCases, setLastCaseDate, setOptionalCasesDetails } from '../../../Redux/CaseSlice';
import { setIsActiveSpinner } from '../../../Redux/GeneralSlice';
import CaseService from '../../../Services/http/CaseService';

export const getCases = async (dispatch, queryParams, screenType) => {
  if (!queryParams['fieldText'] || queryParams['fieldText'] === '') {
    dispatch(setIsActiveSpinner(true));
  }
  queryParams['screenType'] = screenType;
  const response = await CaseService.getCasesList(queryParams);
  if (response && response["message"] === "success") {
    dispatch(setCases(response["items"]));
    dispatch(setLastCaseDate(response["last_case_date"]));
  }
  dispatch(setIsActiveSpinner(false));
};

export const updateStatusCase = async (
  dispatch,
  casesId,
  status,
  queryParams,
  screenType
) => {
  dispatch(setIsActiveSpinner(true));
  const response = await CaseService.updateStatusCase(
    casesId,
    status
  );
  
  getCases(dispatch, queryParams, screenType);
  if (!response || response["message"] !== "success") {
    const message = response ? response["message"] : null;
    if (message === "account_id invalid") {
      alert("Case ID invalid for this account");
    } else {
      alert("error");
    }
  }
  dispatch(setIsActiveSpinner(false));
};

export const getCasesByShipmentId = async (dispatch, accountId, shipmentId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await CaseService.getCasesByShipmentId(accountId, shipmentId);
  dispatch(setIsActiveSpinner(false));
  
  if (response && response["items"]) {
    dispatch(setCases(response["items"]));
  }
};

export const getOptionalCasesDetails = async (dispatch, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await CaseService.getOptionalCasesDetails(
    accountId
  );
  dispatch(setIsActiveSpinner(false));
  if (response) {
    dispatch(setOptionalCasesDetails(response));
  }
  return response;
};

export const updateCaseNumberToRow = async (
  dispatch,
  account_id,
  pk,
  caseNumber,
  queryParams,
  screenType
) => {
  dispatch(setIsActiveSpinner(true));
  const response = await CaseService.updateCaseNumber(
    account_id,
    pk,
    caseNumber
  );
  await getCases(dispatch, queryParams, screenType);
  if (!response || response["message"] !== "success") {
    const message = response ? response["message"] : null;
    if (message === "account_id not match") {
      alert("Case Number invalid for this account");
    } else {
      alert("error");
    }
  }
  dispatch(setIsActiveSpinner(false));
};

export const getShipmentCases = async (dispatch, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await CaseService.getShipmentCases(accountId);
  dispatch(setIsActiveSpinner(false));
  if (response["items"]) {
    dispatch(setShipmentCases(response["items"]));
  }
};

export const getShipmentCasesWithoutDismissed = async (dispatch, accountId) => {
  dispatch(setIsActiveSpinner(true));
  
  const response = await CaseService.getShipmentCases(accountId);
  
  dispatch(setIsActiveSpinner(false));
  
  if (response && response["items"]) {
    const filteredCases = response["items"].filter(item => item.status_case_type !== 'dismissed');
    dispatch(setShipmentCases(filteredCases));
  }
};

export const downloadShipmentsToExcel = async (dispatch, accountId) => {
  dispatch(setIsActiveSpinner(true));
  await CaseService.downloadShipmentsToExcel(accountId);
  dispatch(setIsActiveSpinner(false));
};

export const emptyCases = (dispatch) => {
  dispatch(setCases([]));
};

export const downloadCasesFile = async (dispatch, account_id) => {
  dispatch(setIsActiveSpinner(true));
  await CaseService.downloadCasesFile(account_id);
  dispatch(setIsActiveSpinner(false));
};
